import fetch from "isomorphic-unfetch";
import { resolveStorefrontToken } from "@hooks/useStorefront";

const cleanGraphQLResponse = function(input) {
  if (!input) return null
  const output = {}
  const isObject = obj => {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj)
  }

  Object.keys(input).forEach(key => {
    if (input[key] && input[key].edges) {
      output[key] = input[key].edges.map(edge =>
        cleanGraphQLResponse(edge.node)
      )
    } else if (isObject(input[key])) {
      output[key] = cleanGraphQLResponse(input[key])
    } else if (key !== '__typename') {
      output[key] = input[key]
    }
  })

  return output
}

export default async function graphqlFetch(query, { variables = {} } = {}, isFrench = false) {
  const { storefront_uri, access_token  } = resolveStorefrontToken();
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Shopify-Storefront-Access-Token": access_token,
  };

  if (isFrench) {
    headers["Accept-Language"] = "fr";
  }
  const res = await fetch(storefront_uri, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  if (res.status !== 200) {
    throw new Error(res.statusText);
  }

  const json = await res.json();

  if (json.errors) {
    throw new Error(json.errors);
  }

  return cleanGraphQLResponse(json.data);
}

export async function graphqlAdminFetch(query, { variables = {} } = {}) {
  const res = await fetch(process.env.SHOPIFY_STORE_ADMIN_URI, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Shopify-Access-Token": process.env.SHOPIFY_ADMIN_PASSWORD,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  if (res.status !== 200) {
    throw new Error(res.statusText);
  }

  const json = await res.json();

  if (json.errors) {
    throw new Error(json.errors);
  }

  return json.data;
}
